import {
  ADD_PAYMENT_FORMULAS,
  DELETE_PAYMENT_FORMULAS,
  GET_PAYMENT_FORMULAS,
  GET_PAYMENT_FORMULAS_FOR_ID,
  GET_PAYMENT_FORMULAS_PARAMS,
  HIDE_LOADER_PAYMENT_FORMULAS,
  PATCH_PAYMENT_FORMULAS,
  SET_ERROR_PAYMENT_FORMULAS,
  SET_PAYMENT_FORMULAS,
  SET_PAYMENT_FORMULAS_FOR_ID,
  SET_PAYMENT_FORMULAS_PARAMS,
  SHOW_LOADER_PAYMENT_FORMULAS
} from "./actionType.js";

export const getPaymentFormulas = data => ({
  type: GET_PAYMENT_FORMULAS,
  payload: data,
});

export const setPaymentFormulas = payload => ({
  type: SET_PAYMENT_FORMULAS,
  payload,
});

export const getPaymentFormulasParams = data => ({
  type: GET_PAYMENT_FORMULAS_PARAMS,
  payload: data,
});

export const setPaymentFormulasParams = payload => ({
  type: SET_PAYMENT_FORMULAS_PARAMS,
  payload: payload,
});

export const addPaymentFormulas = (formula = {}, data = {}) => ({
  type: ADD_PAYMENT_FORMULAS,
  payload: { formula, data },
});

export const deletePaymentFormulas = (id, data) => ({
  type: DELETE_PAYMENT_FORMULAS,
  payload: { id, data },
});

export const patchPaymentFormulas = (id, formula, data) => ({
  type: PATCH_PAYMENT_FORMULAS,
  payload: { id, formula, data },
});

export const getPaymentFormulasForId = id => ({
  type: GET_PAYMENT_FORMULAS_FOR_ID,
  payload: id,
});

export const setPaymentFormulasForId = payload => ({
  type: SET_PAYMENT_FORMULAS_FOR_ID,
  payload
});

export const showPaymentFormulasLoader = () => ({
  type: SHOW_LOADER_PAYMENT_FORMULAS,
});

export const hidePaymentFormulasLoader = () => ({
  type: HIDE_LOADER_PAYMENT_FORMULAS,
});

export const setErrorPaymentFormulas = payload => ({
  type: SET_ERROR_PAYMENT_FORMULAS,
  payload
});
